import React from 'react';

export default function RelatedPostsConfig({ data, onChange }) {
  const postSlugs = data.postSlugs || [];

  const updateSlug = (index, value) => {
    const newSlugs = [...postSlugs];
    newSlugs[index] = value;
    onChange({ ...data, postSlugs: newSlugs });
  };

  const addSlug = () => {
    onChange({ ...data, postSlugs: [...postSlugs, ''] });
  };

  const removeSlug = (index) => {
    onChange({ ...data, postSlugs: postSlugs.filter((_, i) => i !== index) });
  };

  return (
    <>
      <div className="adminblog-field">
        <label>Section Title</label>
        <input type="text" value={data.title || ''} onChange={(e) => onChange({ ...data, title: e.target.value })} placeholder="Continúa explorando" />
      </div>
      <div className="adminblog-field">
        <label>Description</label>
        <textarea value={data.description || ''} onChange={(e) => onChange({ ...data, description: e.target.value })} placeholder="Section description..." rows={3} />
      </div>
      <div className="adminblog-field">
        <label>Layout</label>
        <select value={data.layout || 2} onChange={(e) => onChange({ ...data, layout: parseInt(e.target.value) })}>
          <option value={2}>2 columns</option>
          <option value={3}>3 columns</option>
        </select>
      </div>
      <div className="adminblog-field">
        <label>Post Slugs ({postSlugs.length})</label>
        {postSlugs.map((slug, i) => (
          <div key={i} className="adminblog-list-item">
            <input type="text" value={slug} onChange={(e) => updateSlug(i, e.target.value)} placeholder="post-slug" />
            <button className="adminblog-list-remove" onClick={() => removeSlug(i)}>×</button>
          </div>
        ))}
        <button className="adminblog-list-add" onClick={addSlug}>+ Add Post</button>
        <p style={{ fontSize: 11, color: '#999', marginTop: 4 }}>Leave empty to show latest published posts</p>
      </div>
    </>
  );
}
